"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType["Add"] = "ADD";
    ActionType["Modify"] = "MODIFY";
    ActionType["GetCart"] = "GET_CART";
    ActionType["ClearCart"] = "CLEAR_CART";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
